import React, { Component, Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './accessPointRow.styles';

class AccessPointTableHeader extends Component {
  render() {
    return (
      <Fragment>
        <p className={css(styles.heading)}>
          {I18n.t('accessPointTableHeader.title')}
        </p>
        <div className={css(styles.bases)}>
          <div className={css(styles.fieldsHeader, styles.statusHeader)}>
            {I18n.t('accessPointTableHeader.status')}
          </div>
          <div className={css(styles.fieldsHeader, styles.nodeAddressHeader)}>
            {I18n.t('accessPointTableHeader.name')}
          </div>
          <div className={css(styles.fieldsHeader, styles.nodeAddressHeader)}>
            {I18n.t('accessPointTableHeader.nodeAddress')}
          </div>
          <div className={css(styles.fieldsHeader, styles.rpHeader)}>
            {I18n.t('accessPointTableHeader.rpcount')}
          </div>
          <div className={css(styles.fieldsHeader, styles.tagHeader)}>
            {I18n.t('accessPointTableHeader.tagcount')}
          </div>

          <div className={css(styles.fieldsHeader, styles.lastseenapHeader)}>
            {I18n.t('accessPointTableHeader.lastseenap')}
          </div>
          <div className={css(styles.fieldsHeader, styles.trash)} />
        </div>
      </Fragment>
    );
  }
}

export default AccessPointTableHeader;



// WEBPACK FOOTER //
// ./src/components/data/status/accesspoint/accessPointTableHeader.js